import React from "react";

const HelpStyle = {
  minWidth: "100%",
};
const iframeStyle = {
  width: "100%",
  minHeight: "80vh",
};

const Help = () => {
  return (
    <>
      <div style={HelpStyle}>
        <iframe
          title="Presentation"
          src="https://onedrive.live.com/embed?cid=C80AFA7B37F5312B&amp;resid=C80AFA7B37F5312B%2111071&amp;authkey=AElad1x5Ru_HTcg&amp;em=2&amp;wdAr=1.7777777777777777"
          style={iframeStyle}
          frameBorder="0"
        >
          This is an embedded{" "}
          <a target="_blank" href="https://office.com" rel="noreferrer">
            Microsoft Office
          </a>{" "}
          presentation, powered by{" "}
          <a target="_blank" href="https://office.com/webapps" rel="noreferrer">
            Office
          </a>
        </iframe>
      </div>
    </>
  );
};

export default Help;
